<template>
    <div class="img-container-loader">
        <img src="https://i.pinimg.com/originals/ec/d6/bc/ecd6bc09da634e4e2efa16b571618a22.gif" alt="" class = "preloader" />
    </div>
</template>

<style scoped>
.img-container-loader{
    display:flex;
    height:100vh;
    align-items: center;
    justify-content: center;
}
.preloader{

}
</style>